import { tabsClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const name = 'StatisticsTabs';

export const useStatisticsTabsStyles = makeStyles({ name })(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,

    [`&& .${tabsClasses.root}`]: {
      minHeight: 'unset',
    },

    [`&& .${tabsClasses.indicator}`]: {
      height: 2,
    },

    [`&& .${tabsClasses.flexContainer}`]: {
      gap: theme.spacing(5),
    },
  },
  tab: {
    minHeight: 'unset',
    padding: theme.spacing(0, 0, 3, 0),
    minWidth: 'unset',
    textTransform: 'none',
  },
}));
